<template>
    <div class="budget-followup-hours">
        <div v-if="data">
            <div class="row">
                <div class="col-lg-8">
                    <div class="placeholder">
                        <div class="placeholder__heading">
                            <d-tooltip identifier="budgetfollowup.hours.graph" placement="left" />
                            Solgte timer fordelt pr. måned
                        </div>
                        <div class="placeholder padding">
                            <vue-apex-charts
                                :height="300"
                                :series="hoursGraphSeries"
                                :options="hoursGraphOptions"
                                type="bar"
                                v-if="data && hoursGraphSeries.length > 0"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="placeholder">
                        <div class="placeholder__heading">
                            <d-tooltip identifier="budgetfollowup.hours.yeartodate" placement="left" />
                            Budgetåret til dato
                        </div>
                        <div class="placeholder padding">
                            <div class="line">
                                <div class="left">Faktisk</div>
                                <div class="right">{{ data.hours.year_to_date.actual | number }} timer</div>
                            </div>
                            <div class="line">
                                <div class="left">Budget</div>
                                <div class="right">{{ data.hours.year_to_date.budget | number }} timer</div>
                            </div>
                            <div class="line">
                                <div class="left">Difference</div>
                                <div class="right" :class="{'color-good': data.hours.year_to_date.diff > 0, 'color-bad': data.hours.year_to_date.diff < 0}">{{ data.hours.year_to_date.diff | number }} timer</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <box-loading />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.line {
    display: flex;
    justify-content: space-between;
    font-weight: 700;

    &:not(:last-of-type) {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
    }
}
</style>

<script>
import * as budgetService from '@/services/budgetService'
import VueApexCharts from 'vue-apexcharts'

export default {
    data () {
        return {
            data: null,
            hoursGraphSeries: [],
            hoursGraphOptions: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value > 0) {
                                return this.$options.filters.number(value) + ' timer'
                            } else {
                                return '0 timer'
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#4CAF50'],
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            }
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            budgetService.hours({}, (response) => {
                this.hoursGraphOptions.labels = response.data.hours.graph.labels
                this.hoursGraphSeries.push({name: 'Budget', data: response.data.hours.graph.budget_series})
                this.hoursGraphSeries.push({name: 'Faktisk', data: response.data.hours.graph.actual_series})
                this.data = response.data
                console.log(response.data)
            }, (err) => {
                console.log(err)
            })
        }
    },
    components: {
        VueApexCharts
    }
}
</script>



// WEBPACK FOOTER //
// budgetHours.vue?448aca36